import { useQuery } from "react-query";
import { AppService } from "../../../services/app/app.service";
export var useMarketplaceAppsQuery = function (enabled) {
    if (enabled === void 0) { enabled = true; }
    return useQuery('allMarketplaceApps', function () {
        return AppService.getAll({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "order", direction: "DESC" }]
            }
        });
    }, { enabled: enabled });
};
export var useMarketplaceApps = function () {
    var _a;
    var query = useMarketplaceAppsQuery();
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
